/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IntendedBoardUse {
    Development = 0,
    Production = 1,
    AdHoc = 2,
    Maintenance = 3,
}
